import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class CheckableBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.checkable = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let checkable = ko.unwrap(valueAccessor());

                if (!checkable)
                    element.find('.k-checkbox-label').first().css('display', 'none');
                else
                    element.find('.k-checkbox-label').first().css('display', '');
            }
        };
    }
}